// Utilitaires de compression/décompression pour le cache
import { logger } from '../logger';

/**
 * Compresse des données en utilisant une compression simple
 * Pour les grands objets, on pourrait utiliser une vraie bibliothèque de compression
 */
export function compress(data: any): any {
  try {
    // Pour l'instant, on fait juste une sérialisation
    // Dans une vraie implémentation, on utiliserait une bibliothèque comme pako ou lz-string
    const serialized = JSON.stringify(data);
    return serialized;
  } catch (error) {
    logger.error('Compression failed', {
      category: 'Cache',
      data: error
    });
    return data;
  }
}

/**
 * Décompresse des données
 */
export function decompress(data: any): any {
  try {
    // Pour l'instant, on fait juste une désérialisation
    return JSON.parse(data);
  } catch (error) {
    logger.error('Decompression failed', {
      category: 'Cache',
      data: error
    });
    return data;
  }
}